interface ILoggerFormat {
    timestamp: number;
    severity: string;
    message: string;
    resultCode?: number;
    data?: unknown;
}

class Logger {
    public debug(message: string, data?: unknown, resultCode?: number): void {
        this.log("debug", message, data, resultCode);
    }

    public info(message: string, data?: unknown, resultCode?: number): void {
        this.log("info", message, data, resultCode);
    }

    public warn(message: string, data?: unknown, resultCode?: number): void {
        this.log("warn", message, data, resultCode);
    }

    public error(message: string, data?: unknown, resultCode?: number): void {
        this.log("error", message, data, resultCode);
    }

    private log(
        level: "debug" | "info" | "warn" | "error",
        message: string,
        data?: unknown,
        resultCode?: number,
    ): void {
        const log: ILoggerFormat = {
            timestamp: Date.now(),
            severity: `${level}`.toUpperCase(),
            message,
            resultCode,
            data: data ?? undefined,
        };

        console.log(JSON.stringify(log));
    }
}

export default new Logger();
